import React, { useState } from 'react';
import axiosInstance from 'axios';
import { Trash2 } from 'lucide-react';
import toast from 'react-hot-toast';
import ConfirmDeleteModal from './confirmDeleteModal';
import { Admin_Employee_Campaign } from '../../../../constants';
import { Box, Button, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

const EmployeeTable = ({
  employees,
  campaignId,
  onEmployeeRemoved,
  refetch,
}) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const handleDeleteClick = (employee) => {
    setSelectedEmployee(employee);
    setDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!selectedEmployee) return;
    setDeleting(true);
    try {
      const res = await axiosInstance.delete(
        `${Admin_Employee_Campaign}`,
        {
          data: {
            EmployeeId: selectedEmployee.EmployeeId,
            CampaignId: campaignId,
          },
        }
      );
      if (res.data.success) {
        if (onEmployeeRemoved) onEmployeeRemoved(selectedEmployee.EmployeeId);
        toast.success('Employee removed successfully');
        if (refetch) await refetch();
      } else {
        alert(res.data.message || 'Failed to remove employee');
      }
    } catch (err) {
      alert('Error removing employee');
    } finally {
      setDeleting(false);
      setDeleteModalOpen(false);
      setSelectedEmployee(null);
    }
  };

  return (
    // <div className="overflow-x-auto">
    //   <table className="table w-full">
    //     <thead>
    //       <tr>
    //         <th className="text-left">Employee ID</th>
    //         <th className="text-left">Name</th>
    //         <th className="text-left">Phone</th>
    //         <th className="text-left">Actions</th>
    //       </tr>
    //     </thead>
    //     <tbody>
    //       {employees.map((employee) => (
    //         <tr key={employee.EmployeeId} className="hover">
    //           <td>
    //             <span className="font-mono text-sm bg-base-200 px-2 py-1 rounded">
    //               {employee.EmployeeId}
    //             </span>
    //           </td>
    //           <td>
    //             <div className="font-medium">{employee.EmployeeName}</div>
    //           </td>
    //           <td>
    //             <a
    //               href={`tel:${employee.EmployeePhone}`}
    //               className="link link-primary hover:link-hover"
    //             >
    //               {employee.EmployeePhone}
    //             </a>
    //           </td>
    //           <td>
    //             <button
    //               className="btn btn-ghost btn-xs text-error"
    //               onClick={() => handleDeleteClick(employee)}
    //             >
    //               <Trash2 className="w-4 h-4" />
    //             </button>
    //           </td>
    //         </tr>
    //       ))}
         
    //     </tbody>
    //   </table>
    //    <ConfirmDeleteModal
    //         open={deleteModalOpen}
    //         onClose={() => setDeleteModalOpen(false)}
    //         onConfirm={handleConfirmDelete}
    //         employeeName={selectedEmployee?.EmployeeName}
    //         loading={deleting}
    //       />

    //   {employees.length === 0 && (
    //     <div className="text-center py-8 text-base-content/50">
    //       <div className="text-4xl mb-2">👥</div>
    //       <p>No employees assigned to this campaign</p>
    //     </div>
    //   )}
    // </div>
    <Box sx={{ width: '100%', overflowX: 'auto' }}>
      <TableContainer component={Paper} sx={{ mb: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Employee ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {employees.map((employee) => (
              <TableRow key={employee.EmployeeId} hover>
                <TableCell>
                  <Typography
                    variant="body2"
                    sx={{
                      fontFamily: 'monospace',
                      fontSize: '0.95rem',
                      bgcolor: 'grey.100',
                      px: 1,
                      py: 0.5,
                      borderRadius: 1,
                      display: 'inline-block',
                    }}
                  >
                    {employee.EmployeeId}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body1" fontWeight={500}>
                    {employee.EmployeeName}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Button
                    href={`tel:${employee.EmployeePhone}`}
                    color="primary"
                    size="small"
                  >
                    {employee.EmployeePhone}
                  </Button>
                </TableCell>
                <TableCell>
                  <IconButton
                    color="error"
                    size="small"
                    onClick={() => handleDeleteClick(employee)}
                  >
                    <Trash2 style={{ width: 20, height: 20 }} />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <ConfirmDeleteModal
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
        employeeName={selectedEmployee?.EmployeeName}
        loading={deleting}
      />

      {employees.length === 0 && (
        <Box textAlign="center" py={5} color="text.secondary">
          <Typography variant="h2" mb={1}>👥</Typography>
          <Typography>No employees assigned to this campaign</Typography>
        </Box>
      )}
    </Box>
  );
};

export default EmployeeTable;
